<script setup lang="ts">
import type { GetStartedStep } from "../types";

const props = defineProps<{
  currentStep: GetStartedStep;
  stepSubmitting: boolean;
  isDesktop: boolean;
}>();

const emit = defineEmits<(e: "step:complete") => void>();
</script>

<template>
  <div data-testid="get-started-step">
    <h3>Get started</h3>
    <p data-testid="get-started-text">
      This request was sent to {{ currentStep.element_config?.clientName }} ({{
        currentStep.element_config?.clientEmail
      }}).
    </p>
    <p>
      By clicking “Agree & continue” below, I agree to Legl's
      <a href="https://legl.com/terms-of-use/" target="_blank">Terms of use</a>
      &
      <a href="https://legl.com/privacy-policy/" target="_blank"
        >Privacy policy</a
      >.
    </p>
    <div class="button-container">
      <lds-button
        :class="{ 'is-mobile': !isDesktop }"
        id="agree-to-terms-and-continue-button"
        colour="primary"
        @click="emit('step:complete')"
        :disabled="stepSubmitting"
        :isLoading="stepSubmitting"
      >
        Agree & continue
      </lds-button>
    </div>
  </div>
</template>

<style scoped lang="scss">
h3 {
  margin-top: 0;
  @include typography-h3;
  color: $color-neutral-900;
}

p {
  @include typography-body-normal;
  color: $color-neutral-900;

  a {
    color: $color-primary-600;
  }
}

.button-container {
  display: flex;
  justify-content: flex-end;
  margin-top: $spacing-l;
}

.is-mobile {
   width: 100%;
 }
</style>
